import React from 'react'

const BannerText1 = ({ bText }) => {
  return (
    <div className='hihed mt-3'><p>{bText}</p>

    </div>
  )
};

export default BannerText1